export default {
    LOAD_MY_SCHEDULES(state, my_schedules) {
        state.items = my_schedules;
    }
}